exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#search-form{width:100%}#search-box-container{color:#999;line-height:25px;font-style:italic;width:100%}#search-box{margin-top:10px;border-radius:0;border-right:0}#search-btn{margin-top:10px;background-color:#000;border-radius:0;border-color:#999;border-left:0}.form-control:focus,.form-control{margin-top:10px;padding-left:8px;font-family:Calibri,Candara,Segoe,\"Segoe UI\",Optima,Arial,sans-serif;font-size:16px;color:#fff;border-color:#999;background-color:#000;box-shadow:none}::-webkit-input-placeholder{font-style:italic}:-moz-placeholder{font-style:italic}::-moz-placeholder{font-style:italic}:-ms-input-placeholder{font-style:italic}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/forms/SearchForm/styles.scss
// module id = 592
// module chunks = 0